import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium ring-offset-background transition-all focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 rounded-xl transform hover:scale-105 duration-200",
  {
    variants: {
      variant: {
        default:
          "bg-linear-160 from-sylvain-purple to-sylvain-blue to-70% hover:from-sylvain-purple/80 hover:to-sylvain-blue/80 text-white font-semibold py-2 border-0",
        destructive:
          "bg-linear-to-r from-red-500 to-pink-500 hover:from-red-600 hover:to-pink-600 text-white font-semibold py-2 border-0",
        outline:
          "bg-white border-2 border-transparent bg-clip-padding text-indigo-700 font-semibold py-2 border-gradient-to-r from-indigo-600 to-blue-600 hover:bg-indigo-50",
        secondary:
          "bg-white text-foreground font-semibold border-0 hover:bg-gray-200",
        ghost:
          "bg-transparent text-indigo-700 font-semibold py-2 border-0 hover:bg-indigo-50",
        link: "bg-transparent text-indigo-700 underline-offset-4 hover:underline font-semibold py-2 rounded-none shadow-none transform-none border-0",
      },
      size: {
        default: "h-10 px-4 py-2 text-base",
        sm: "h-9 rounded-xl px-3 text-sm",
        lg: "h-11 rounded-xl px-8 text-base",
        xl: "h-12 rounded-xl px-10 text-base",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);
